import { render, staticRenderFns } from "./ManejoSolicitudes.vue?vue&type=template&id=3cff6734"
import script from "./ManejoSolicitudes.vue?vue&type=script&lang=js"
export * from "./ManejoSolicitudes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports